import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import MasterGamesList from "../data/MasterGamesList"

export default function PragmaticPlayDaily() {
  const navigate = useNavigate()
  const data = promotionsData.find((promo) => promo.title === "Super Scatter")
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Super Scatter Daily Tournaments </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> /{" "}
              <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> SUPER SCATTER DAILY TOURNAMENTS </h1>

                <div className="promotion-tnc-period">
                  <strong> Promo Period: </strong>
                  <span>
                    <br />
                    January 19, 2026 - February 02 , 2026 (GMT + 8)
                  </span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <div className="promotion-tnc-btn-wrapper">
                  <a
                    href="/slots/?provider=PP"
                    className="promotion-cta-btn"
                    style={{ cursor: "pointer" }}
                  >
                    Play Now
                  </a>
                </div>
                <strong> Terms and Conditions: </strong>
                <ol>
                  <li>
                    <p>
                      182,000 winners will win cash prizes worth ₱104,991,600
                      from 19 January 2026, 20:00 to 2 February 2026, 00:59
                      (GMT+8).
                    </p>
                  </li>
                  <li>
                    <p>
                      There are 14 daily tournaments during the promotion
                      period, running daily from 19:00 to 23:59 (GMT+8).
                    </p>
                  </li>
                  <li>
                    <p>
                      Winners are based on Largest win from a single spin
                      (adjusted for bet value).
                    </p>
                  </li>
                  <li>
                    <p>
                      Scores = (Largest single win during tournament)/(winning
                      bet during tournament)*100
                    </p>
                  </li>
                  <li>
                    <p>No minimum bet is required for this promotion.</p>
                  </li>
                  <li>
                    <p>
                      Players will win prizes in the form of a multiplier of the
                      winning player’s bet amount as set out in the prize table.
                    </p>
                  </li>
                  <li>
                    <p>
                      If the winning spin exceeds ₱58, the prize will be paid
                      out based on a bet of ₱58 X multiplier received.
                    </p>
                  </li>

                  <MasterGamesList
                    qualifiedGamesOnly="on"
                    customWrapperClass="gameListWrapper promotion-signup-game-list"
                    customQualifiedGames={[
                      {
                        provider: "pp",
                        gameName: "Starlight Princess Super Scatter",
                      },
                      {
                        provider: "pp",
                        gameName: "Fortune Ace Super Scatter",
                      },
                      {
                        provider: "pp",
                        gameName: "Sweet Bonanza Super Scatter",
                      },
                      {
                        provider: "pp",
                        gameName: "Gates of Olympus Super Scatter",
                      },
                      {
                        provider: "pp",
                        gameName: "Gates of Gatot Kaca Super Scatter",
                      },
                      {
                        provider: "pp",
                        gameName: "Sugar Rush Super Scatter"
                      }
                    ]}
                    rank="off"
                    limit={8}
                    headerText={null}
                    linkTo={null}
                    headerTag="h2"
                  />

                  <li>
                    <p>
                      If there are two or more players with identical score in
                      tournament leaderboard, the player who scores it first
                      will get the higher position on the leaderboard.
                    </p>
                  </li>
                  <li>
                    <p>
                      The tournament leaderboard is built in the qualifying
                      games and updates in real time.
                    </p>
                  </li>
                  <li>
                    <p>
                      Pragmatic Play reserves the right to thoroughly review
                      players activities to identify any potential abuse to
                      ensure fair play within our Network Promotion. If any
                      abuse is found, Pragmatic Play reserves the right to
                      forfeit any amounts paid to winning players.
                    </p>
                  </li>
                  <li>
                    <p>
                      Pragmatic Play reserves the right to amend, suspend or
                      cancel the promotion at any time and without prior notice.
                    </p>
                  </li>
                </ol>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0px" }}
                  >
                    <thead>
                      <th> Rank </th>
                      <th> Daily Prizes </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td> 1 </td>
                        <td> x5,000 </td>
                      </tr>
                      <tr>
                        <td> 2-3 </td>
                        <td> x2,000 </td>
                      </tr>
                      <tr>
                        <td> 4-5 </td>
                        <td> x1,000 </td>
                      </tr>
                      <tr>
                        <td> 6-10 </td>
                        <td> x500 </td>
                      </tr>
                      <tr>
                        <td> 11-40 </td>
                        <td> x200 </td>
                      </tr>
                      <tr>
                        <td> 41-100 </td>
                        <td> x100 </td>
                      </tr>
                      <tr>
                        <td> 101-300 </td>
                        <td> x50 </td>
                      </tr>
                      <tr>
                        <td> 301-2,300 </td>
                        <td> x20 </td>
                      </tr>
                      <tr>
                        <td>2,301-15,000</td>
                        <td>x8</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="promotion-tnc-cta">
                  <a
                    href="https://pp88.asia/tl/super-scatter-daily-tournaments/"
                    className="promotion-cta-btn"
                    target="_blank"
                  >
                    View Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
